/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Stack from '@mui/material/Stack'
import CircularProgress from '@mui/material/CircularProgress'

import 'src/services/communication/twilio'
import { useAccountAction, useAccountSelect } from 'src/hooks/useAccount'
import Layout from 'src/layouts/Layout'
import { useSettings } from 'src/hooks/useSettings'
import { useAppSelect } from 'src/hooks/useApp'
import VerticalAppBarContent from './components/vertical/AppBarContent'
import { useAppAction } from 'src/hooks/useApp'
// import { useSearchQuery } from 'src/hooks/useSearchQuery'
import { useStorageSettingsAction } from 'src/hooks/useStorageSettings'
import { ReactRouterRedux } from 'src/components/ReactRouterRedux'
import PresenceBootstrap from 'src/components/presence/PresenceBootstrap'

interface Props {
  contentHeightFixed?: boolean
}

const UserLayout = ({ contentHeightFixed }: Props) => {
  const isAfterLogin = useAccountSelect.isAfterLogin()
  const isUpdatePermissions = useAccountSelect.isUpdatePermissions()
  const isUser = useAccountSelect.isUser()
  const getProfile = useAccountAction.getProfile()
  const getShemas = useAppAction.getSchemas()
  const getSettings = useStorageSettingsAction.getSettings()
  const realtimeConnection = useAppAction.realtimeConnection()
  const getShemasStatus = useAppAction.getSchemas.status()
  const appSchemas = useAppSelect.schemas()
  const [fulfiledSchemas, setFulfiledSchemas] = React.useState(
    appSchemas?.length > 0
  )

  const getRefreshToken = useAccountAction.getRefreshToken()

  const getRefreshTokenStatus = useAccountAction.getRefreshToken.status()
  const isSessionReady = isAfterLogin || getRefreshTokenStatus.isFulfilled

  React.useEffect(() => {
    if (!fulfiledSchemas && getShemasStatus.isFulfilled) {
      setFulfiledSchemas(true)
    }
  }, [fulfiledSchemas, getShemasStatus.isFulfilled])

  React.useEffect(() => {
    if (!isAfterLogin && isUser) {
      getRefreshToken({})
    }
  }, [isAfterLogin, isUser])

  React.useEffect(() => {
    if (!isUser || !isSessionReady) return

    getSettings({})
    realtimeConnection()
    getShemas({ perPage: 10 })
    getProfile()
  }, [isUser, isSessionReady])

  const { settings, saveSettings } = useSettings()

  const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const isLoading = !isSessionReady || !fulfiledSchemas

  if (!isUser) {
    return <Navigate to="/login" replace />
  }

  if (isLoading && !isUpdatePermissions)
    return (
      <Stack
        sx={{
          flex: 1,
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Stack>
    )

  return (
    <Layout
      hidden={hidden}
      settings={settings}
      saveSettings={saveSettings}
      contentHeightFixed={contentHeightFixed}
      verticalLayoutProps={{
        appBar: {
          content: (props: { pathggleNavVisibility: any }) => (
            <VerticalAppBarContent
              hidden={hidden}
              settings={settings}
              saveSettings={saveSettings}
              toggleNavVisibility={props.pathggleNavVisibility}
            />
          ),
        },
      }}
    >
      <PresenceBootstrap />
      <ReactRouterRedux>
        <Stack mx={{ xs: 3, xl: 6 }} sx={{ height: '100%' }} flex={1}>
          <Outlet />
        </Stack>
      </ReactRouterRedux>
    </Layout>
  )
}

export default UserLayout
